import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DashboardTodolistItem as SchemaDashboardTodolistItem } from '../schemas/DashboardTodolistItem';
import { type DashboardTodolistItemUpdate as SchemaDashboardTodolistItemUpdate } from '../schemas/DashboardTodolistItemUpdate';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Dashboard
 * @summary Mark todolist item as complete or incomplete
 */
export const UpdateDashboardTodolistItemCompleteStatusContentType = 'application/json' as const;
export type UpdateDashboardTodolistItemCompleteStatusRequest = SchemaDashboardTodolistItemUpdate;
export type UpdateDashboardTodolistItemCompleteStatusResponses = LinkCommonErrorResponses & {
    /**
     * @description Updated todolist item
     */
    '200': {
        'application/json': SchemaDashboardTodolistItem;
    };
    /**
     * @description Todolist item not found
     */
    '404': {
        'application/json': SchemaError;
    };
};
export type UpdateDashboardTodolistItemCompleteStatusResponseSuccess =
    UpdateDashboardTodolistItemCompleteStatusResponses['200']['application/json'];
export type UpdateDashboardTodolistItemCompleteStatusSearchParams = undefined;
export type UpdateDashboardTodolistItemCompleteStatusPathParameters = {
    id: string;
};
export const UpdateDashboardTodolistItemCompleteStatusUrl = '/dashboard/todolist/{id}' as const;
export const UpdateDashboardTodolistItemCompleteStatusMethod = 'PATCH' as const;
export const getUpdateDashboardTodolistItemCompleteStatusUrl = (
    params: UpdateDashboardTodolistItemCompleteStatusPathParameters
) =>
    UpdateDashboardTodolistItemCompleteStatusUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof UpdateDashboardTodolistItemCompleteStatusPathParameters) => String(params[param])
    );
